import { FC, useEffect, useState } from "react";
import { IMember, Member } from "../store/member";
import { userStore } from "../store/userStore";
import MemberForm from "./MemberForm";
import { Card, CardHeader, Switch } from "@fluentui/react-components";

interface MainProps {}

const AccountInfo: FC<MainProps> = () => {
    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [userState, setUserState] = useState<IMember | null>(userStore.currentState);

    useEffect(() => {
        userStore.subscribe((x) => {
            setUserState(x);
        });
    }, []);

    return (
        <>
            {/* <Card style={{margin:5}}>
                <CardHeader header={<h2>Conference Registrations</h2>} />
                <div>Registrations go here</div>
            </Card> */}
            <Card style={{margin:5}}>
                <CardHeader header={<h2>Personal Information</h2>} />
                
                <Switch label={"Edit Your Personal Details & Change Username OR Password"} checked={isEditing} onChange={(_, data) => setIsEditing(data.checked)}></Switch>
                <MemberForm member={userState !== null ? userState : new Member()} readonly={!isEditing}></MemberForm>
            </Card>
        </>
    );
};

export default AccountInfo;
